import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("edil_cookie_consent")) {
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (value) => {
    localStorage.setItem("edil_cookie_consent", value);
    // Notifica i componenti (es. Google Analytics) del consenso in tempo reale
    window.dispatchEvent(new CustomEvent("cookie-consent-changed", { detail: value }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-50 bg-[#1B2A41] text-white p-6 rounded-2xl shadow-2xl border border-white/10 backdrop-blur-xl animate-fade-up" data-testid="cookie-banner">
      <div className="flex items-start gap-3">
        <Cookie className="w-6 h-6 text-[#E0961C] shrink-0 mt-0.5" />
        <div>
          <h3 className="font-semibold text-[15px]">Rispettiamo la tua privacy</h3>
          <p className="text-sm text-white/70 mt-1 leading-relaxed">
            Utilizziamo cookie tecnici necessari al funzionamento e, previo tuo consenso, cookie di analisi (Google Analytics) per capire come viene usato il sito. Puoi accettare o rifiutare i cookie non essenziali.{" "}
            <Link to="/privacy-policy" className="text-[#6FB3EC] underline underline-offset-2" data-testid="cookie-privacy-link">
              Maggiori informazioni
            </Link>
          </p>
        </div>
      </div>
      <div className="flex gap-2 mt-4">
        <button onClick={() => decide("accepted")} className="flex-1 bg-[#2472C8] hover:bg-[#1E5FA6] text-white text-sm font-semibold py-2.5 rounded-full transition-colors" data-testid="cookie-accept-btn">
          Accetta tutti
        </button>
        <button onClick={() => decide("essential")} className="flex-1 bg-white/10 hover:bg-white/15 text-white text-sm font-semibold py-2.5 rounded-full transition-colors" data-testid="cookie-reject-btn">
          Solo essenziali
        </button>
      </div>
    </div>
  );
};
